var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.207 5.207L9.793 0.793C9.60551 0.605451 9.3512 0.500057 9.086 0.5H1.5C1.23478 0.5 0.98043 0.605357 0.792893 0.792893C0.605357 0.98043 0.5 1.23478 0.5 1.5V15.5C0.5 15.7652 0.605357 16.0196 0.792893 16.2071C0.98043 16.3946 1.23478 16.5 1.5 16.5H13.5C13.7652 16.5 14.0196 16.3946 14.2071 16.2071C14.3946 16.0196 14.5 15.7652 14.5 15.5V5.914C14.4999 5.64881 14.3945 5.39449 14.207 5.207ZM12.5 14.5H2.5V2.5H8.5V5.5C8.5 5.76522 8.60536 6.01957 8.79289 6.20711C8.98043 6.39464 9.23478 6.5 9.5 6.5H12.5V14.5Z",
    fill: "#8596A4"
  })));
};
export default __webpack_public_path__ + "static/media/icon-onboarding-record-file.be47fa97.svg";
export { SvgComponent as ReactComponent };